import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export function TrustReassuranceSection() {
  const items = [
    'No setup fees',
    'No per-user fees',
    'No per-location fees',
    'No overage penalties',
  ];

  return (
    <section className="py-8 px-4 bg-slate-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-slate-900 mb-6" style={{ fontFamily: 'Manrope' }}>
          Why Businesses Choose ReStaff
        </h2>
        
        <div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
            {items.map((item, index) => (
              <div 
                key={index} 
                className="flex flex-col items-center text-center gap-2"
              >
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <CheckCircle2 size={28} className="text-orange-600" strokeWidth={2.5} />
                </div>
                <p className="text-sm md:text-base font-medium text-slate-700 leading-snug">
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
